import React from 'react';
import { Select, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';
import { ProductInfo, ProductKey } from '../compareData';
import { ChevronDownIcon } from '../CompareIcons';
import { GRAY, INK, MOBILE, MUTED } from '../constants';

interface CollarSelectorProps {
  index: number;
  product: ProductInfo;
  options: { value: ProductKey; label: string }[];
  onSelect: (index: number, chosen: ProductKey) => void;
  onShop: (product: ProductInfo) => void;
}

/** Sticky-bar column: label, collar dropdown, Shop button. */
export const CollarSelector: React.FC<CollarSelectorProps> = ({ index, product, options, onSelect, onShop }) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={12} miw={0}>
      <Text c={GRAY} sx={{ fontSize: 15, [MOBILE]: { fontSize: 12 } }}>
        {t('compare_v2_select_collar', { number: index + 1 })}
      </Text>
      <Select
        aria-label={t('select_product')}
        data={options}
        value={product.key}
        onChange={(value) => value && onSelect(index, value as ProductKey)}
        radius={999}
        rightSection={<ChevronDownIcon />}
        rightSectionWidth={44}
        styles={{
          input: {
            minHeight: 52,
            height: 'auto',
            padding: '14px 44px 14px 20px',
            fontSize: 17,
            fontWeight: 600,
            border: `1px solid ${MUTED}`,
            color: INK,
          },
          rightSection: { pointerEvents: 'none', '& svg': { width: 14, height: 14 } },
        }}
      />
      <Button onClick={() => onShop(product)}>
        {t('compare_v2_shop_product', { product: t(product.shopNameKey ?? product.nameKey) })}
      </Button>
    </Stack>
  );
};
